module["exports"] = [
  "s.r.o.",
  "a.s.",
  "v.o.s."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/company/suffix.js
// module id = 219
// module chunks = 0